// @ts-ignore
import {request} from '@/utils/request.js'

//首页媒体、客服、用户信息接口
export const getHomePage = () =>request('/api/index/index')
export const getHomePageTel = () =>request('/api/index/tel')

//首页产品账户类型
export const getAccountType = () =>request(`/api/index/productcate`)

//首页产品账户资金列表
export const getAccountFundsList = (id) =>request(`/api/index/productpricecate?t=${id}`)

//首页产品信息接口
export const getProductDetail = (id) =>request(`/api/index/productinfo?id=${id}`)

//首页产品描述信息接口
export const getProductDesc = (id='') =>request(`/api/index/productkey?t=${id}`)

//首页获取广告活动
export const getActivityLink = () =>request(`/api/index/adv`)

//获取注册量
export const getRegistrationVolume = () =>request(`/api/wap/getacountsnum`)